export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden border-y border-slate-200 bg-white ${className}`} data-testid="stats-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center gap-12 py-4 pr-12" aria-hidden={half === 1}>
          {items.map((item, i) => (
            <span
              key={i}
              className="flex items-center gap-12 whitespace-nowrap font-mono-data text-[11px] font-medium uppercase tracking-[0.22em] text-slate-500"
            >
              {item}
              <span className="h-1.5 w-1.5 rotate-45 bg-[#b91c1c]/40" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
